import { ReactElement } from "react";

const TermsAndConditions = (): ReactElement => {
  const privacyPolicyUrl = "https://www.justworks.com/platform-privacy-policy";
  const termsOfUseUrl = "https://justworks.com/terms-of-use";
  const californiaPrivacyNoticeUrl =
    "https://www.justworks.com/platform-privacy-policy#toc-additional-information-for-california-residents";

  return (
    <div>
      By creating an account you confirm that you have read and agree to the
      Justworks{" "}
      <a className="milo--link" href={privacyPolicyUrl}>
        Privacy Policy
      </a>
      ,{" "}
      <a className="milo--link" href={termsOfUseUrl}>
        Terms of Use
      </a>
      , and, if applicable, the{" "}
      <a className="milo--link" href={californiaPrivacyNoticeUrl}>
        California Privacy Notice
      </a>
      .
    </div>
  );
};

export default TermsAndConditions;
